module.exports = __webpack_public_path__ + "static/us_bank-b43414f37d156bfe49a4d49ceef4acd8.png";